import React, { useEffect, useState } from "react";
import { getCategoryBooks, getNewBooks, getBookStroys, getSeed } from "../../api";
import { useIsMobile } from "../../hooks/useIsMobile";
import BookStoryLayout from "./BookStoryLayout";
import usePageTitle from "../../hooks/usePageTitle";

export default function BookStoryContainer() {
    usePageTitle("북밋 작품 소개");

    const isMobile = useIsMobile();
    const [page, setPage] = useState(0);
    const [newBooks, setNewBooks] = useState<any>([]);
    const [bookStory, setBookStory] = useState<any>([]);
    const [bookCategory, setBookCategory] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentGenre, setCurrentGenre] = useState('소설');
    const [hasMore, setHasMore] = useState(true);

    const [seed, setSeed] = useState("");

    useEffect(() => {
        async function fetchSeed() {
            try {
                const data = await getSeed();
                // console.log(data);
                setSeed(data);
            } catch (error) {
                console.error("Failed to fetch seed:", error);
            }
        }
        if (seed === "") {
            fetchSeed();
        }
    }, [seed]);

    const onGenreSelect = async (genre: string) => {

        setIsLoading(true);
        setPage(1); // 페이지를 1로 초기화
        setHasMore(true);
        const data = await getCategoryBooks(genre, 1, seed);
        setBookCategory(data);
        setCurrentGenre(genre);
        setIsLoading(false);
    };

    const onLoadMore = async () => {
        if (isLoading || !hasMore) return;

        setIsLoading(true);

        setPage((prevPage) => { //이전 페이지 수 가져와서 업데이트
            const nextPage = prevPage + 1;

            // console.log("Loading next page:", nextPage);
            loadBooks(nextPage);
            return nextPage;
        });
    };

    //기존에 로드모어에서 그냥 같이 실행했는데 page 업데이트가 비동기로 제대로 안 이루어져서 분리함
    const loadBooks = async (nextPage: number) => {
        const data = await getCategoryBooks(currentGenre, nextPage, seed);

        if (data.length > 0) {
            setBookCategory((prev: any) => [...prev, ...data]);
        } else {
            setHasMore(false); // 더 이상 로드할 데이터가 없으면 hasMore를 false로 설정
        }

        setIsLoading(false);
    };


    useEffect(() => {

        const getData = async () => {
            const data = await getNewBooks();
            setNewBooks(data);
        };
        getData();

        const booksecondData = async () => {
            const data = await getBookStroys();
            setBookStory(data);
        };
        booksecondData();

        // onGenreSelect('소설'); // 여기서 로드 안 해도 됨
    }, []);



    return (
        <BookStoryLayout
            newBooks={newBooks}
            bookStory={bookStory}
            isMobile={isMobile}
            onGenreSelect={onGenreSelect}
            onLoadMore={onLoadMore}
            bookCategory={bookCategory}
        />
    );
}
